<template>
  <div class="orgTreePage">
    <vue2-org-tree
      :data="data"
      :horizontal="true"
      collapsable
      :props="orgTreeProps"
      @on-expand="onExpand"
      @on-node-mouseover="onMouseover"
      @on-node-mouseout="onMouseout"
    />
    <div ref="myTips" class="myTips" v-show="myTipsShow">
      <div class="content">
        <el-tooltip class="item" effect="dark" content="新建" placement="top" :open-delay="300">
          <i @click="addNewOrg" class="el-icon-plus"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300">
          <i @click="editOrgInfo" class="el-icon-edit"></i>
        </el-tooltip>
        <el-tooltip
          v-if="itemData.enable"
          class="item"
          effect="dark"
          content="禁用"
          placement="top"
          :open-delay="300"
        >
          <i @click="disableOrg" class="iconfont icon-qiyong"></i>
        </el-tooltip>
        <el-tooltip
          v-else
          class="item"
          effect="dark"
          content="启用"
          placement="top"
          :open-delay="300"
        >
          <i @click="enableOrg" class="iconfont icon-jinyong"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="上移" placement="top" :open-delay="300">
          <i @click="moveUpOrg" class="el-icon-arrow-up"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="下移" placement="top" :open-delay="300">
          <i @click="moveDownOrg" class="el-icon-arrow-down"></i>
        </el-tooltip>
      </div>
      <div class="arrow"></div>
    </div>
    <myMask ref="myMask" @closeMask="closeMask"></myMask>
  </div>
</template>

<script>
import { apiOrgShow } from "@/api/userApi.js";
import myMask from "@/components/myMask.vue";
export default {
  components: {
    myMask
  },
  data() {
    return {
      data: {},
      orgTreeProps: { label: "newName", children: "children", expand: "expand" },
      itemEvent: {},
      itemData: {},
      timer: "",
      myTipsShow: false
    };
  },
  methods: {
    async getOrgShow(remove, callback) {
      if (!(remove == "noRemove")) {
        this.data = {};
      }
      const res = await apiOrgShow();
      // console.log(res);
      if (res.code == 0) {
        this.data = res.data;
        this.$parent.pullDownData.orgOptions = [res.data];
        this.expandChange();
        if (callback) callback();
      }
    },
    onExpand(e, data) {
      if ("expand" in data) {
        data.expand = !data.expand;
        if (!data.expand && data.children) {
          this.collapse(data.children);
        }
      } else {
        this.$set(data, "expand", true);
      }
    },
    collapse(list) {
      list.forEach(child => {
        if (child.expand) {
          child.expand = false;
        }
        child.children && this.collapse(child.children);
      });
    },
    onMouseover(e, data) {
      this.itemEvent = e;
      this.itemData = data;
      this.timer = setTimeout(() => {
        e.target.addEventListener("dblclick", this.showMyTips);
      }, 300);
    },
    onMouseout() {
      clearTimeout(this.timer);
      this.itemEvent.target.removeEventListener("dblclick", this.showMyTips);
    },
    closeMask() {
      this.myTipsShow = false;
      this.$refs.myMask.show = false;
      this.itemEvent.target.style.userSelect = "auto";
    },
    showMyTips() {
      let labelDiv = this.itemEvent.target;
      labelDiv.style.userSelect = "none";
      this.myTipsShow = true;
      let top = labelDiv.getBoundingClientRect().top;
      let left = labelDiv.getBoundingClientRect().left;
      let myTips = this.$refs.myTips;
      this.$nextTick(() => {
        myTips.style.top = top - myTips.clientHeight - 10 + "px";
        myTips.style.left =
          left + labelDiv.clientWidth / 2 - myTips.clientWidth / 2 + "px";
      });
      this.$refs.myMask.show = true;
    },
    expandChange() {
      this.toggleExpand(this.data, true);
    },
    toggleExpand(data, val) {
      if (Array.isArray(data)) {
        data.forEach(item => {
          this.$set(item, "expand", val);
          // 处理标签括号中内容
          this.$set(item, "newName", item.name);
          if(item.type && item.type.productionLine) {
            item.newName = `${item.name}（${item.type.name}）`
          }
          if (item.children) {
            this.toggleExpand(item.children, val);
          }
        });
      } else {
        this.$set(data, "expand", val);
          // 处理标签括号中内容
          this.$set(data, "newName", data.name);
          if(data.type && data.type.productionLine) {
            data.newName = `${data.name}（${data.type.name}）`
          }
        if (data.children) {
          this.toggleExpand(data.children, val);
        }
      }
    },
    // 新建
    addNewOrg() {
      this.$parent.addNewBtn(this.itemEvent, this.itemData);
      this.closeMask();
    },
    // 修改
    editOrgInfo() {
      this.$parent.editOrgInfo(this.itemEvent, this.itemData);
      this.closeMask();
    },
    // 禁用
    disableOrg() {
      this.$parent.disableOrg(this.itemEvent, this.itemData);
      this.closeMask();
    },
    // 启用
    enableOrg() {
      this.$parent.enableOrg(this.itemEvent, this.itemData);
      this.closeMask();
    },
    // 上移
    moveUpOrg() {
      this.$parent.moveUpOrg(this.itemEvent, this.itemData);
      this.closeMask();
    },
    // 下移
    moveDownOrg() {
      this.$parent.moveDownOrg(this.itemEvent, this.itemData);
      this.closeMask();
    }
  }
};
</script>

<style lang="less" scoped>

</style>